import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=270beb42&scoped=true&"
import script from "./InformationBlock.ts?vue&type=script&lang=ts&"
export * from "./InformationBlock.ts?vue&type=script&lang=ts&"
import style0 from "./InformationBlock.scss?vue&type=style&index=0&id=270beb42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270beb42",
  null
  
)

export default component.exports